import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateDialog, NoOp } from '../../ui/action-creators';
import store from '../../index';
import * as merch from '@webapp/sdk/merch';
import {
  ChangeMerchType,
  ChangeMerchTypeError,
  ChangeMerchTypeSuccess,
} from '../action-creators';
import { CHANGE_MERCH_TYPE } from '../actions';
import AppState from '../../state';

export const confirmChangeMerchTypeEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, ChangeMerchType>(CHANGE_MERCH_TYPE),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (
        !!state.merch.active?.product &&
        state.merch.active?.product.id === action.product.id
      ) {
        return new NoOp();
      }

      const artist = state.artist.active;
      const productId =
        state.merch.active?.editProduct?.id ||
        state.merch.active?.newProduct?.productId;

      if (artist && productId) {
        return new CreateDialog(`CHANGE_MERCH_TYPE.${action.product.id}`, {
          open: true,
          title: `Are you sure you want to change the product?`,
          text: `All the data you have already entered will be lost.`,
          actions: [
            { type: 'primary', label: 'No', value: false },
            { type: 'secondary', label: 'Yes', value: true },
          ],
          callback: async (result) => {
            if (result) {
              try {
                await merch.takeDown(artist.id, productId);
                return store.dispatch(
                  new ChangeMerchTypeSuccess(action.product)
                );
              } catch (err) {
                return store.dispatch(new ChangeMerchTypeError(err.message));
              }
            }
          },
        });
      }

      return new ChangeMerchTypeSuccess(action.product);
    })
  );
